import { Api } from '@monorepo/shared/apiClient';
import {
  invalidateProjectUsersCache,
  ProjectUsersCacheEvents,
} from '@monorepo/shared/cacheRegisters/users/projectUsersCacheRegister';
import { MutationConfig, useMutation } from 'react-query';

type UseInviteUserToProjectParams = {
  config?: MutationConfig<
    Api.InviteUserToProjectResponse,
    Api.ErrorResponse,
    Api.InviteUserToProjectParams
  >;
};

export const useInviteUserToProject = (params?: UseInviteUserToProjectParams) =>
  useMutation(Api.inviteUserToProject, {
    ...params?.config,
    onSuccess: (data, vars) => {
      invalidateProjectUsersCache(ProjectUsersCacheEvents.CREATE, {
        projectId: vars.projectId,
      });
      return params?.config?.onSuccess?.(data, vars);
    },
    onError: (error, variables, rollback) =>
      params?.config?.onError?.(error, variables, rollback),
  });
